module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/225.e817bf74.png";